export const GET_USER_SETTINGS = 'getUserSettings';
export const UPDATE_USER_NOTIFICATIONS_SETTINGS = 'updateUserNotificationsSettings';
export const UPDATE_USER_OPEX_DISPLAY = 'updateUserOpexDisplay';
export const UPDATE_RECORD_PERMISSIONS = 'updateRecordPermissions';
